import React, { Component } from "react";
import { connect } from "react-redux";
import moment from 'moment';
import { Grid, Col, Row, Button, ControlLabel } from "react-bootstrap";
import JqxGrid, { jqx } from "jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid";
import "jqwidgets-scripts/jqwidgets/styles/jqx.material.css";
import DatePicker from 'react-date-picker';
import Card from "../../../components/Card/Card";
import { dominio } from "../../../routes_backend/routes";
import { PDFReporte } from "../../../components/utils/Pdf_produccion.js";
import _ from "lodash";
import Loading from "../../../views/Loading";
import "./style.css";
import Swal from 'sweetalert2';  // Importa SweetAlert2





// const myGrid = React.createRef();
export class CtrlCombustibleExtCartelera extends Component {
  constructor(props) {
    super(props);


    this.state = {


      from_Date: new Date(),
      to_Date: new Date(),
      message: "",
      isLoading: false,
      source_grid: "",
      source_gridUnidades: "",
      dataGraphic: '',



    columns: [
        { text: "Documento", datafield: "DocNum",  width: '5%', pinned:'true', cellsalign: "center", align: "center",  editable: false } ,
        { text: "Vale", datafield: "U_NoVale",  width: '5%', pinned:'true', cellsalign: "center",  align: "center", editable: false } ,
        { text: "Fecha", datafield: "FechaDespachoF",  width: '7%', cellsalign: "center",  align: "center", editable: false } ,
        { text: "Unidad", datafield: "U_Unidad",  width: '7%', cellsalign: "center",  align: "center", editable: false } ,
        { text: "Gls", datafield: "U_Galones",  width: '7%', cellsalign: "center",  cellsformat: 'f2', align: "center", editable: false } ,
        { text: "Piloto", datafield: "U_Piloto",  width: '16%', cellsalign: "center",  align: "center", editable: false } ,
        { text: "Descipcion", datafield: "U_Descripcion",  width: '7%', cellsalign: "center",  align: "center", editable: false } ,
        { text: "Comentario", datafield: "Comments",  width: '8%', cellsalign: "center",  align: "center", editable: false } ,
        { text: "Origen", datafield: "U_Origen",  width: '7%', cellsalign: "center",  align: "center", editable: false } ,
        { text: "Destino", datafield: "U_Destino",  width: '7%', cellsalign: "center",  align: "center", editable: false } ,
        { text: "Cartelera", datafield: "Cartelera", width: '5%', cellsalign: "center", cellsformat: 'f2',   align: "center",   } ,
        { text: "Cobro", datafield: "Cobro", width: '5%', cellsalign: "center", cellsformat: 'f2',   align: "center", editable: false } ,
        { text: "Total", datafield: "Total", width: '5%', cellsalign: "center", cellsformat: 'f2',   align: "center", editable: false } ,
        { datafield: "Crear", align: "center", width: "9%", editable: true, columntype: "button", /*cellclassname: "special",*/
          buttonclick: (row) => {
            const dataRecord = this.gridRef.current.getrowdata(row);
            var docentry, docnum, vale, fechaDespacho, unidad, galones, piloto, descripcion, comentario, origen, destino, cartelera, cobro, total;
            docentry = dataRecord.DocEntry; 
            docnum = dataRecord.DocNum; 
            vale = dataRecord.U_NoVale; 
            fechaDespacho = dataRecord.U_FechaDespacho; 
            unidad = dataRecord.U_Unidad; 
            galones = dataRecord.U_Galones; 
            piloto = dataRecord.U_Piloto; 
            descripcion = dataRecord.U_Descripcion; 
            comentario = dataRecord.Comments; 
            origen = dataRecord.U_Origen; 
            destino = dataRecord.U_Destino; 
            cartelera = dataRecord.Cartelera; 
            cobro = dataRecord.Cobro; 
            total = dataRecord.Total; 


          // console.log(docentry, docnum, vale, fechaDespacho, unidad, galones, piloto, descripcion, comentario, origen, destino, cartelera, cobro, total);
          

              this.saveBtn(docentry, docnum, vale, fechaDespacho, unidad, galones, piloto, descripcion, comentario, origen, destino, cartelera, cobro, total );


          },
          cellsrenderer: function () {
            return "Crear";
          }
        },   
      ],

    };
       this.gridRef = React.createRef(); // Define el ref
       this.onCellEndEdit = this.onCellEndEdit.bind(this);
  }


  onCellEndEdit(event) {
  const { args } = event;
  const { datafield, rowindex, value } = args;

  if (datafield === "Cartelera") {
    const grid = this.gridRef.current;
    const rowData = grid.getrowdata(rowindex); // Accede a los datos de la fila

    if (!rowData) return; // Asegúrate de que la fila exista

    const galones = parseFloat(rowData.U_Galones || 0);
    const cobro = parseFloat(value) - 0.50;
    const total = galones * cobro;

    // Actualizar los valores en las columnas Cobro y Total
    grid.setcellvalue(rowindex, "Cobro", cobro.toFixed(2));
    grid.setcellvalue(rowindex, "Total", total.toFixed(2));
  }
}


  onChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,

    });
  };
  onChangeFromDate(date) {
    this.setState({ from_Date: date });
  }
  onChangeToDate(date) {
    this.setState({ to_Date: date });
  }


  clear = () => {
    this.setState({

      message: "",
      isLoading: false,
      source_grid: "",
      from_Date: new Date(),
      to_Date: new Date(),
    });
  };



  // data = (event) => {
  //   this.data()
  //   // this.dataUnidades()
  // };

  data = () => {
    const { from_Date, to_Date } = this.state;
   let username = "";
    let password = "";

    let token = localStorage.getItem("token");
    let token_Data = JSON.parse(token);
    if (token_Data !== null) {
      token_Data.forEach((element) => {
        username = element.usuarioSAP;
        password = element.contraseñaSAP;
      });
    }

    if (token_Data === null) {
      this.props.history.push("");
    }
    
    let from = moment(from_Date).format('YYYYMMDD');
    let to = moment(to_Date).format('YYYYMMDD');
  
    this.setState({
      isLoading: true,
    });

 fetch(`${dominio}/get_ValesDespachadosExternos`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        username,
        password,
        from,
        to
      }),
    })



      .then(async (res) => {
        let data = await res.json();
        console.log(data);
  
        const temp_res = Object.entries(data).length === 0; // true
        if (temp_res === true) {
          return this.setState({
            message: "no data",
            source_grid: "",
            isLoading: false,
          });
        }
        let array_source = [];
        data.forEach((element) => {
          let array = {
            DocEntry: element.DocEntry,
            DocNum: element.DocNum,
            U_NoVale: element.U_NoVale,
            U_FechaDespacho: element.U_FechaDespacho,
            FechaDespachoF: element.FechaDespachoF,
            U_Unidad: element.U_Unidad,
            U_Galones: element.U_Galones,
            U_Piloto: element.U_Piloto,
            U_Descripcion: element.U_Descripcion,
            Comments: element.Comments,
            U_Origen: element.U_Origen,
            U_Destino: element.U_Destino,
            Cartelera: element.Cartelera,
            Cobro: element.Cobro,
            Total: element.Total,
            U_EstatusFactura: element.U_EstatusFactura,
          };
  
          array_source.push(array);
        });
  
        let temp_grid = {
          data: [],
          localdata: array_source,
          datafields: [
            { name: "DocEntry", type: "string" },
            { name: "DocNum", type: "string" },
            { name: "U_NoVale", type: "string" },
            { name: "U_FechaDespacho", type: "string" },
            { name: "FechaDespachoF", type: "string" },
            { name: "U_Unidad", type: "string" },
            { name: "U_Galones", type: "number" },
            { name: "U_Piloto", type: "string" },
            { name: "U_Descripcion", type: "string" },
            { name: "Comments", type: "string" },
            { name: "U_Origen", type: "string" },
            { name: "U_Destino", type: "string" },
            { name: "Cartelera", type: "number", },
            { name: "Cobro", type: "number" },
            { name: "Total", type: "number" },
            { name: "U_EstatusFactura", type: "string" },
       
          ],
          datatype: "json",
        };
  
        this.setState({
          data: temp_grid,
          isLoading: false,
          source_grid: new jqx.dataAdapter(temp_grid),
          message: "",
        });
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
          message: "error in server",
        });
      });
  };



   saveBtn = (docentry, docnum, vale, fechaDespacho, unidad, galones, piloto, descripcion, comentario, origen, destino, cartelera, cobro, total) => {
   this.setState({
      isLoading: true,
    });
      
  
  
        var username = "";
        var password = "";
        var User_Code = "";
        var User_Id = "";
        let token = localStorage.getItem("token");
        let token_Data = JSON.parse(token);
        if (token_Data !== null) {
          token_Data.forEach((element) => {
            username = element.usuarioSAP;
            password = element.contraseñaSAP;
            User_Code = element.user_code;
            User_Id = element.user_id;
          });
        }
        console.log(User_Code, User_Id);
        
  
        if (token_Data === null) {
          this.props.history.push("");
        }
  
        fetch(`${dominio}/CtrlCombuExtCartelera`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      username,
      password,
      docentry, docnum, vale, fechaDespacho, unidad, galones, piloto, descripcion, comentario, origen, destino, cartelera, cobro, total
    }),
  })

  .then(res => {
    // Si el status no es 200-299, forzamos que pase al catch con el texto del error
    if (!res.ok) return res.json().then(err => { throw err; });
    return res.json();
  })
  .then(data => {
     this.setState({
      isLoading: false,
    });
    if (data.success) {
      Swal.fire({
        icon: 'success',
        title: 'Éxito',
        text: data.message || 'Dato agregado exitosamente'
      }).then(() => {
        this.data(); // refrescar datos
      });
    } else {
      // En caso que no venga success pero tampoco error (por si acaso)
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Ocurrió un error desconocido'
      }).then(() => {
        this.data(); // refrescar datos
      });
      
    }
  })
  .catch(error => {
    this.setState({ isLoading: false });
    // Aquí atrapamos los errores, que incluirán tu mensaje personalizado
    Swal.fire({
      icon: 'error',
      title: 'Error en la solicitud',
      text: error.error || 'Mensaje de error no disponible'
    }).then(() => {
        this.data(); // refrescar datos
      });
  
  });
};


  render() {
    const {  message, isLoading, from_Date, to_Date } = this.state;


    return (
      <div
        className="content"
        style={{ textAlign: "center", alignItems: "center" }}
      >

        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Control de Desapacho diesel Externos"
                category=""
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div className="row">
                    <div>
                      <div className="row">
                        <div className="col-sm-2">
                          <ControlLabel>Del: </ControlLabel>
                          <br />
                          <DatePicker
                            onChange={(from_Date) => this.onChangeFromDate(from_Date)}
                            value={from_Date}
                          />
                        </div>
                        <div className="col-sm-2">
                          <ControlLabel>Al: </ControlLabel>
                          <br />
                          <DatePicker
                            onChange={(to_Date) => this.onChangeToDate(to_Date)}
                            value={to_Date}
                          />
                        </div>

                        {/*  */}

         



                        <div className="col-sm-3">
                          <br />
                          <Button
                            onClick={this.data}
                            bsStyle="primary"
                            bsSize="small"
                            active
                          >
                            Search
                          </Button>
                          &nbsp;
                          <Button
                            onClick={this.clear}
                            bsStyle="danger"
                            bsSize="small"
                            active
                          >
                            Clear
                          </Button>
                          <p style={style.errorMessage}>{message}</p>
                        </div>
                      </div>
                      <br />
                       <br />
                        <br />
                         <br />
                          <br />
                           <br />
                     
                      {!_.isEmpty(this.state.source_grid) ? (
                        <div className="col-sm-12">

                          <br />
                          <br />
                          <div className="col-sm-12">
                            <div className="col-sm-12">
                              <p style={{ fontWeight: "bold", color: "red", fontSize: "30px" }}>
                              Actualizar Cartelera
                              </p>
                              <br />
                              <br />
                              <JqxGrid
                                ref={this.gridRef} 
                                width={"100%"}
                                height={"600px"}
                                columns={this.state.columns}
                                source={this.state.source_grid}
                                theme={"material"}
                                editable={true}
                                filterable={true}
                                selectionmode={"singlerow"}
                                showfilterrow={true}
                                altrows={true}
                                enabletooltips={true}
                                columnsresize={true}
                                showtoolbar={true}
                                sortable={true}
                                showstatusbar={true}
                                showaggregates={true}
                               onCellendedit={this.onCellEndEdit}
                              />
                  
                            </div>
                          </div>
                     

                          
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
        {isLoading && <Loading />}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}
export default connect(mapStateToProps, { PDFReporte })(
  CtrlCombustibleExtCartelera
);
const style = {
  text: {
    textAlign: "center",
  },

  errorMessage: {
    fontWeight: "bold",
    fontSize: "12px",
    height: "10px",
    color: "red",
  },
};
